<template>
  <form class="step" @submit.prevent="submit">
    <p class="step__title text_x_large">{{i18n.kyc_submit_document()}}</p>
    <div class="step__row">
      <file-field class="kyc-form__file-field"
                  id="kyc-business-model"
                  v-model="documents[documentTypes.kycBusinessModel]"
                  v-validate="'required'"
                  :label="i18n.kyc_upload_business_model()"
                  :type="documentTypes.kycBusinessModel"
                  :data-vv-as="i18n.kyc_upload_business_model()"
                  :disabled="accountState === ACCOUNT_STATES.pending"
                  v-on:input="onFileInput($event)"
      />
    </div>
    <div class="step__description">
      <md-checkbox v-model="form.privacyPolicy"
                   name="privacy-policy"
                   id="privacy-policy"
                   :errorMessage="errorMessage('privacy-policy')"
                   class="md-primary privacy-policy__cb">
      </md-checkbox>
      <span v-html="i18n.kyc_i_agree()"></span>
    </div>
    <div class="btn-wrap margin-top">
      <md-button type="submit" class="btn md-primary"
                :disabled="isPending || accountState === ACCOUNT_STATES.pending || !form.privacyPolicy">
        {{ i18n.lbl_submit() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from '../../spec/step.mixin'
  import FormMixin from '@com/mixins/form.mixin'
  import { ASSET_POLICIES, ACCOUNT_STATES, documentTypes } from '@const'
  import { commonEvents } from '@js/events/common_events'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { i18n } from '@js/i18n'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import _cloneDeep from 'lodash/cloneDeep'
  import { vuexTypes } from '@vuex/types'
  import { mapGetters } from 'vuex'

  export default {
    name: 'StepBusinessModel',
    mixins: [StepMixin, FormMixin],
    data: _ => ({
      form: {},
      documents: {},
      i18n,
      documentTypes,
      ASSET_POLICIES,
      ACCOUNT_STATES
    }),

    computed: {
      ...mapGetters([
        vuexTypes.accountState
      ])
    },

    methods: {
      async submit () {
        if (!await this.isValid()) return
        // if (!this.isValidDocs(this.schema.requiredDocs)) return
        if (!this.form.privacyPolicy) {
          EventDispatcher.dispatchShowErrorEvent(i18n.kyc_not_privacy_policy())
          return false
        }
        this.disable()
        try {
          await this.uploadDocuments()
          this.$emit(commonEvents.kycUpdateEvent, {
            form: this.form,
            documents: this.documents,
            finalize: true
          })
        } catch (error) {
          this.enable()
          ErrorHandler.processUnexpected(error)
        }
      },
      stubData () {
        this.form = _cloneDeep(this.kyc)
        this.documents = _cloneDeep(this.kyc.documents)
      },
      async onFileInput (e) {
        try {
          await this.uploadDocuments()
          this.$emit(commonEvents.kycUpdateEvent, {
            form: this.form,
            documents: this.documents,
            finalize: false
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
      }
    },
    watch: {
      activeStep (value) {
        if (value === this.finalStep) {
          this.stubData()
        }
      }
    }
  }
</script>

<style scoped>
  .privacy-policy__cb {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/verification/steps/syndicate/Step.BusinessModel.vue